export default function showHiddenElements() {
  const nodes = document.querySelectorAll('.hidden');

  if (typeof nodes.forEach === 'function') {
    nodes.forEach((node) => node.classList.remove('hidden'));
  } else {
    Array.prototype.forEach.call(nodes, (node) => {
      node.classList.remove('hidden');
    });
  }
}
